// extracted by mini-css-extract-plugin
export var MuiPopperRoot = "S_bK";
export var MuiTooltipPopper = "S_bL";
export var button = "S_bP";
export var icon = "S_n";
export var iconWrapper = "S_bN";
export var title = "S_7";
export var wrapper = "S_bM";